<template>
  <form @submit.prevent="">
    <ZDialog :show="isVisible" :modal-size="modalSize">
      <template #header>
        <div class="custom-header-wrapper">
          <div class="row">
            <div class="col custom-header">
              <span class="custom-header-title">{{ header }}</span>
              <span>{{ yrMakeModel }}</span>
            </div>
            <div class="col-3">
              <z-select v-model="insurance" :options="insuranceCompanies" :option-groups="insuranceGroups"
                :disabled="isResultSaving" label="Insurance"></z-select>
            </div>
            <div class="col-2">
              <div class="row">
                <div class="col text-right">
                  <!-- <h4>Blueprint</h4> -->
                </div>
                <div class="col-2 text-center pt-1">
                  <a href="#" class="custom-close" @click="close">
                    <i class="fa fa-times"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #body>
        <div class="hostWrapper" :class="{ 'custom-host-adasiq': currentTab === 'ADAS IQ' }">
          <ZTabs v-model="currentTab" :tabs="tabs" :disabled="isResultSaving" @change="setTab" />
          <div v-if="currentTab === 'Line Items'" class="row">
            <LineEntries @refresh="refreshInspection()" />
          </div>
          <div v-if="currentTab === 'ADAS Map'" class="row p-2">
            <AdasInspection ref="refAdasInspection" />
          </div>
          <div v-if="currentTab === 'Mobile Copilot'" class="row p-2">
            <McpRequest ref="refMcpRequest" :mcpLoaded="mcpLoaded" />
          </div>
          <div v-if="currentTab === 'IVS Wizard'" class="row p-2">
            <IvsWizard ref="refIvsWizard" />
          </div>
          <!-- <div v-if="currentTab === 'FIT REV'" class="row p-2">
            <FitConsumables ref="refFitConsumables" />
          </div> -->
          <div v-if="currentTab === 'Scans'" class="row p-2">
            <VehicleScans />
          </div>
          <!--
          <div v-if="currentTab === 'ALLDATA'" class="row p-4">
            <div class="col"></div>
            <div class="col text-center"><button class="btn btn-primary" @click="gotoAllData()">Go to ALLDATA</button>
            </div>
            <div class="col"></div>
          </div>
          <div v-if="currentTab === 'RepairLogic'" class="row p-2">
            <span>RepairLogic coming soon</span>
          </div>
          -->
          <!-- <div v-if="currentTab === 'I-CAR RTS'" class="row p-4">
            <ICarRTS />
          </div>
          <div v-if="currentTab === 'OEM 1-Stop'" class="row p-4">
            <OEM1Stop :make="make" />
          </div> -->
          <div v-if="currentTab === 'Repair Plan Info'" class="row p-2">
            <RepairPlanInfo />
          </div>
          <div v-if="currentTab === 'Assistants'" class="row p-2 custom-ai-wrapper">
            <AiPrompt ref="aiPrompt" :ai-prompt="selectedPrompt" :firm="firm" :vehicle="vehicle"
              :adas-inspection="adasInspection" :unique-id="uniqueId" />
          </div>
          <div v-if="currentTab === 'ADAS IQ'" class="row p-2 custom-adasiq-tab">
            <div class="col">
              <!-- Fills the dialog body under the tabs (710): sized from the window, the frame
                   overflowed the body on tall screens and the body opened scrolled. -->
              <AdasIqEmbed :context="adasIqContext" height="100%" />
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div v-if="currentTab === 'ADAS Map'" class="custom-footer">
          <div class="col-6">
            <div v-show="!dontShow">
              <button v-if="isBMS && !isComplete" type="button" class="btn btn-sm btn-secondary" :disabled="isLoading || isResultSaving"
                @click="scrubRepairData()">
                <FontAwesomeIcon v-if="isLoading" icon="fa-solid fa-spinner" spin /> Scrub
              </button>
              <button type="button" class="btn btn-sm btn-secondary ms-1" :disabled="isLoading || isResultSaving"
                @click="emailReport('Report')">Email Report</button>
              <button type="button" class="btn btn-sm btn-secondary ms-1" :disabled="isLoading || isResultSaving"
                @click="showReport()">Report</button>
              <button v-if="isBMS && isCCC" type="button" class="btn btn-sm btn-secondary ms-1" :disabled="isLoading || isResultSaving"
                @click="pushReportToCCC()">
                Push to CCC
              </button>
              <button v-if="!isComplete" type="button" class="btn btn-sm btn-secondary ms-1" :disabled="isLoading || isResultSaving"
                @click="sendToCalCopilot()">Create Calibration</button>
              <a v-if="isBMS" href="#" class="ms-2" @click="showRepairLines">Repair Lines</a>
            </div>
          </div>
          <div class="col custom-complete">
            <button v-if="!isComplete && !dontShow" type="button" class="btn btn-success" :disabled="isLoading || isResultSaving"
              @click="completeInspection()">
              Complete Inspection
            </button>
          </div>
          <div v-if="!isComplete" class="col-4 custom-right-align">
            <span v-if="isResultSaving" class="me-2 text-muted">
              <FontAwesomeIcon icon="fa-solid fa-spinner" spin /> Saving...
            </span>
            <button type="button" class="btn btn-light" :disabled="isResultSaving" @click="close()">Cancel</button>
            <button v-show="inspectionTab === 'Inspection' || inspectionTab === 'Results'" type="button"
              class="btn btn-primary ms-1" :class="{ 'btn-danger': isSave }" :disabled="isLoading || isResultSaving"
              @click="saveInspection(false)">
              Save
            </button>
            <button v-show="inspectionTab === 'Inspection' || inspectionTab === 'Results'" type="button"
              class="btn ms-1" :class="{ 'btn-outline-danger': isSave, 'btn-primary': !isSave }" :disabled="isLoading || isResultSaving"
              @click="saveInspection(true)">
              Save and Close
            </button>
          </div>
          <div v-else class="col-4 custom-right-align">
            <button type="button" class="btn btn-primary" :disabled="isResultSaving" @click="close()">Okay</button>
          </div>
        </div>
        <div v-else class="row custom-footer">
          <div class="col-2">
            <span title="ADAS Inspection ID">{{ ids }}</span>
          </div>
          <div v-if="currentTab === 'Assistants' && isSuperAdmin" class="col custom-prompt-wrapper">
            <div class="input-group">
              <select v-model="selectedAi" class="form-select" :disabled="isExecutingPrompt"
                @change="selectAiPrompt(selectedAi, false)">
                <option v-for="ai in aiListItems" :key="ai.ai" :value="ai.ai">{{ ai.aiName }}</option>
              </select>
              <button v-if="selectedPrompt != null" class="btn btn-success" type="button" :disabled="isExecutingPrompt"
                @click="runAiPrompt()">Run</button>
              <button class="btn btn-primary custom-spacer" type="button" :disabled="isExecutingPrompt"
                @click="addPrompt()">Add</button>
              <button class="btn btn-primary custom-spacer" type="button"
                :disabled="isExecutingPrompt || !selectedPrompt" @click="editPrompt()">Edit</button>
              <button class="btn btn-primary custom-spacer" type="button"
                :disabled="isExecutingPrompt || !selectedPrompt" @click="deletePrompt()">Delete</button>
              <button v-if="isResponseThere" class="btn btn-primary custom-spacer" type="button"
                :disabled="isExecutingPrompt" @click="printResponse()">Print</button>
            </div>
          </div>
          <div v-else-if="currentTab === 'Assistants'" class="col-4 custom-prompt-wrapper">
            <div class="input-group">
              <select v-model="selectedAi" class="form-select" :disabled="isExecutingPrompt"
                @change="selectAiPrompt(selectedAi, false)">
                <option v-for="ai in aiListItems" :key="ai.ai" :value="ai.ai">{{ ai.aiName }}</option>
              </select>
              <button class="btn btn-primary btn-sm ms-2" type="button" :disabled="isExecutingPrompt"
                @click="selectAiPrompt(selectedAi, true)">Refresh Results</button>
            </div>
          </div>
          <div v-else-if="!(currentTab === 'Assistants')" class="col text-center">
            <div class="input-group custom-actions">
              <button v-if="isProvider" class="btn btn-primary btn-sm" @click="gotoProviders()">Go to
                Providers</button>
              <button v-if="!isInsurer" class="btn btn-primary btn-sm custom-actions-button" @click="gotoAllData()">Go
                to ALLDATA</button>
              <button class="btn btn-primary btn-sm custom-actions-button" @click="gotoOEM1Stop()">Go to OEM 1
                Stop</button>
              <button class="btn btn-primary btn-sm custom-actions-button" @click="gotoICarRTS()">Go to I-Car
                RTS</button>
              <!-- <button v-if="!isInsurer" class="btn btn-primary btn-sm custom-actions-button" @click="gotoFITREV()">Go
                to
                FIT REV</button> -->
            </div>
          </div>
          <div v-if="currentTab === 'Assistants' && !isSuperAdmin" class="col-1 pt-2">
            <button v-if="isResponseThere" class="btn btn-primary" type="button" :disabled="isExecutingPrompt"
              @click="printResponse()">Print</button>
          </div>
          <div class="col text-right">
            <button v-if="hasEstimateSource" type="button" class="btn btn-success btn-sm me-2"
              @click="showInvoice()">Invoice</button>
            <button type="button" class="btn btn-default" @click="close()">Close</button>
          </div>
        </div>
      </template>
    </ZDialog>
  </form>
  <DialogAIEdit v-model="actionAIPrompt" @close="closeModal" @save="savePrompt" />
  <ConfirmDialog v-model="actionConfirm" :confirmTitle="confirmTitle" :confirmAction="confirmAction"
    :confirmQuestion="confirmQuestion" @closing="closeModal" @proceed="performConfirmation" />
  <ConfirmDialog v-model="actionInsuranceConfirm" confirmTitle="Change Insurance?" confirmAction="Change"
    :confirmQuestion="insuranceConfirmQuestion" @closing="cancelInsuranceChange" @proceed="confirmInsuranceChange" />
  <ConfirmDialog v-model="actionInsuranceSummary" confirmTitle="Pricing Updated" confirmAction=""
    cancelAction="OK" :confirmQuestion="insuranceSummaryHtml" @closing="actionInsuranceSummary = false" />
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { inspectionStore } from '@/stores/inspection'
import { authStore } from '@/stores/auth'
import { aiStore } from '@/stores/ai'
import { lookupStore } from '@/stores/lookup'
import { locationStore } from '@/stores/location'
import { adasIqStore } from '@/stores/adasIq'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import ZTabs from '@/components/utilities/elements/Tabs.vue'
import ZSelect from '@/components/utilities/elements/Select.vue'
import AdasInspection from '@/components/blueprint/forms/AdasInspection.vue'
import LineEntries from '@/components/blueprint/forms/LineEntries.vue'
import DialogAIEdit from '@/components/ai/ai-edit-dialog.vue'
import ConfirmDialog from '@/components/utilities/elements/ConfirmDialog.vue'
import AiPrompt from '@/components/ai/ai-prompt.vue'
import RepairPlanInfo from '@/components/blueprint/forms/RepairPlanInfo.vue'
import VehicleScans from '@/components/blueprint/forms/VehicleScans.vue'
import ICarRTS from './ICarRTS.vue'
import OEM1Stop from './OEM1Stop.vue'
// import FitConsumables from './FitConsumables.vue'
import McpRequest from './McpRequest.vue'
import IvsWizard from './IvsWizard.vue'
import AdasIqEmbed from '@/components/adas-iq/AdasIqEmbed.vue'
import globals from '@/plugins/globals'
export default {
  name: 'DialogBlueprint',
  components: {
    FontAwesomeIcon,
    ZDialog,
    ZTabs,
    ZSelect,
    AdasInspection,
    LineEntries,
    DialogAIEdit,
    ConfirmDialog,
    AiPrompt,
    RepairPlanInfo,
    VehicleScans,
    ICarRTS,
    OEM1Stop,
    //FitConsumables,
    McpRequest,
    IvsWizard,
    AdasIqEmbed
  },
  props: {
    modelValue: Object
  },
  data() {
    return {
      modalSize: 'modal-xl',
      isSave: false,
      currentTab: 'Line Items',
      isSaving: false,
      isResultSaving: false,
      resultSavingTimer: null,
      isLinesStale: false,
      isThere: false,
      isLoading: false,
      inspectionTab: 'Results',
      isBMS: false,
      isCCC: false,
      isComplete: false,
      dontShow: false,
      actionAIPrompt: null,
      selectedAi: -2,
      selectedPrompt: null,
      actionConfirm: null,
      confirmTitle: 'Remove AI Prompt?',
      confirmAction: 'Remove',
      confirmQuestion: 'Are you sure you wish to Remove this AI Prompt?',
      isGoingToProviders: false,
      mcpLoaded: true,
      isRefreshAI: false,
      pendingInsurance: null,
      actionInsuranceConfirm: false,
      actionInsuranceSummary: false,
      insuranceSummaryHtml: ''
    }
  },
  mounted() {
    adasIqStore().check()
    this.isGoingToProviders = false
    this.currentTab = 'Line Items'
    this.isLoading = true
    this.isThere = false
    this.mcpLoaded = true
    this.selectedAi = -2
    this.selectedPrompt = null
    this.emitter.on('process-consumables', async (data) => {
      if (this.inspection) {
        if (parseInt(this.inspection.adasInspection) === parseInt(data.adasInspection)) {
          await this.getInspection(this.inspection.adasInspection)
        }
      }
    })
    this.init()
  },
  emits: ['report', 'closing', 'refresh'],
  watch: {
    // optional starting tab, e.g. the Systems Overview opens straight onto ADAS Map
    modelValue(value) {
      if (value && value.tab) {
        this.currentTab = value.tab
      }
    },
    firm: {
      immediate: true,
      async handler(value) {
        if (value !== null && value !== undefined) {
          await this.getOptInInsurers(value)
        }
      }
    }
  },
  computed: {
    ...mapState(inspectionStore, ['inspection', 'alldataLink', 'rtsICarLink', 'oem1StopLink', 'oemLinks', 'fitRevLink']),
    ...mapState(authStore, ['profile']),
    ...mapState(aiStore, ['loading', 'aiList', 'aiPrompt', 'aiResponse']),
    ...mapState(locationStore, ['preferences']),
    ...mapState(lookupStore, ['lookups', 'optInInsurers']),
    ...mapState(adasIqStore, { adasIqAllowed: 'allowed' }),
    isVisible() {
      console.log('modelValue', {
        model: this.modelValue,
        inspection: this.inspection
      })
      return this.modelValue !== null
    },
    tabs() {
      let _tabs = []
      if (this.isInsurer) {
        _tabs = ['Line Items', 'ADAS Map', 'Scans', 'Repair Plan Info']
      } else {
        if (this.profile.mcpToken && this.profile.mcpToken.length > 0) {
          _tabs = ['Line Items', 'ADAS Map', /*'Mobile Copilot',*/ 'IVS Wizard', /*'FIT REV',*/ 'Scans', 'Repair Plan Info' /*, 'Assistants'*/]
        } else {
          _tabs = ['Line Items', 'ADAS Map', 'IVS Wizard', /*'FIT REV',*/ 'Scans', 'Repair Plan Info' /*, 'Assistants'*/]
        }
        // #620: ADAS IQ pinned to this repair, for users ADAS IQ says may use it. Shops and
        // partners only for now: insurer users keep their reduced tab set until the
        // cross-shop history question (ADR-0003) is decided for them.
        if (this.adasIqAllowed) {
          _tabs.push('ADAS IQ')
        }
      }
      return _tabs
    },
    // What the ADAS IQ tab pins: the repair's id and VIN, and a label for the chat list.
    adasIqContext() {
      if (!this.inspection || !this.inspection.adasInspection) {
        return null
      }
      let _label = this.inspection.ronumber ? `RO# ${this.inspection.ronumber}` : `Inspection #${this.inspection.adasInspection}`
      if (this.yrMakeModel) {
        _label = `${_label} - ${this.yrMakeModel}`
      }
      return {
        adasInspection: this.inspection.adasInspection,
        vin: this.inspection.vehicle ? this.inspection.vehicle.vin : null,
        label: _label
      }
    },
    title() {
      let _title = ''
      if (this.inspection) {
        _title = `Inspection #${this.inspection.adasInspection} for ${this.inspection.firmName}`
      }
      return _title
    },
    ids() {
      let _ids = ''
      if (this.inspection) {
        _ids = `${this.inspection.adasInspection}`
      }
      return _ids
    },
    isSuperAdmin() {
      let _is = false
      if ([1].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    isInsurer() {
      let _is = false
      if (this.preferences.length > 0) {
        let item = this.preferences.filter((x) => x.name === 'isInsurer')
        if (item.length > 0) {
          _is = item[0].value === '1' || item[0].value.toUpperCase() === 'TRUE'
        }
      }
      return _is
    },
    isProvider() {
      let _data = false
      if (this.preferences.length > 0) {
        let item = this.preferences.filter((x) => x.name === 'isPartOfProviderPrograms')
        if (item.length > 0) {
          _data = item[0].value === 'true'
        }
      }
      return _data
    },
    firm() {
      let _id = null
      if (this.inspection) {
        _id = this.inspection.firm
      }
      return _id
    },
    uniqueId() {
      let _id = null
      if (this.inspection) {
        _id = this.inspection.adasUUID
      }
      return _id
    },
    header() {
      let _header = null
      if (this.inspection) {
        if (this.inspection.ronumber) {
          _header = `${this.inspection.firmName} - RO# ${this.inspection.ronumber}`
        } else if (this.inspection.adasInspection) {
          _header = `${this.inspection.firmName} - # ${this.inspection.adasInspection}`
        }
      }
      return _header
    },
    insuranceCompanies() {
      let _data = []
      if (this.lookups['Insurance']) {
        _data = globals.sortArray(this.lookups['Insurance'], 'name')
      }
      return _data
    },
    // Issue #640: partners = the shop's opted-in insurers that resolve to
    // insurer-mandated pricing (per blueprint/optInInsurers); null keeps the
    // dropdown flat when the shop has none
    insuranceGroups() {
      let _groups = null
      let optIn = this.firm !== null && this.firm !== undefined ? this.optInInsurers[this.firm] : null
      if (optIn && optIn.length && this.insuranceCompanies.length) {
        let ids = new Set(optIn.map((x) => parseInt(x.insurance)))
        let partners = this.insuranceCompanies.filter((option) => ids.has(parseInt(option.value)))
        if (partners.length) {
          _groups = [
            { label: 'Your insurance partners', options: partners },
            { label: 'All insurers', options: this.insuranceCompanies.filter((option) => !ids.has(parseInt(option.value))) }
          ]
        }
      }
      return _groups
    },
    insurance: {
      get() {
        // while a change awaits confirmation the select shows the pending pick;
        // cancel clears it and the select snaps back to the saved value
        if (this.pendingInsurance !== null) {
          return this.pendingInsurance
        }
        let _insurance = null
        if (this.inspection && this.inspection.insurance) {
          _insurance = this.inspection.insurance
        }
        return _insurance
      },
      set(value) {
        let current = this.inspection && this.inspection.insurance ? this.inspection.insurance : null
        let next = value === null || value === '' ? null : parseInt(value)
        if (next === null || next === current) {
          this.pendingInsurance = null
          return
        }
        this.pendingInsurance = next
        this.actionInsuranceConfirm = true
      }
    },
    insuranceConfirmQuestion() {
      let from = this.inspection && this.inspection.insuranceName ? this.inspection.insuranceName : '(none)'
      return `Change the insurance on this RO from <b>${from}</b> to ` +
        `<b>${this.insuranceNameFor(this.pendingInsurance)}</b>?<br/><br/>` +
        'Line item pricing will be recalculated for the new insurance.'
    },
    aiListItems() {
      let _items = []
      _items.push({
        ai: -2,
        firm: 1,
        aiName: 'Select Prompt',
        aiRole: '',
        aiModel: '',
        prompt: '',
        action: 'choose'
      })
      // if (this.isSuperAdmin) {
      //   _items.push({
      //     ai: -1,
      //     firm: 1,
      //     aiName: 'Create Prompt',
      //     aiRole: '',
      //     aiModel: '',
      //     prompt: '',
      //     action: 'new'
      //   })
      // }
      if (this.aiList) {
        this.aiList.forEach(element => {
          _items.push({
            ai: element.ai,
            firm: 1,
            aiName: element.aiName,
            aiRole: element.aiRole,
            aiModel: element.aiModel,
            prompt: element.prompt,
            action: 'select'
          });
        })
      }
      return _items
    },
    make() {
      let _make = ''
      if (this.inspection && this.inspection.vehicle) {
        _make = this.inspection.vehicle.make
      }
      return _make
    },
    yrMakeModel() {
      let _data = null
      if (this.inspection) {
        if (this.inspection.vehicle) {
          _data = `${this.inspection.vehicle.year} ${this.inspection.vehicle.make} ${this.inspection.vehicle.model}`
        }
      }
      return _data
    },
    firm() {
      let _data = null
      if (this.inspection) {
        _data = this.inspection.firm
      }
      return _data
    },
    adasInspection() {
      let _data = null
      if (this.inspection) {
        _data = this.inspection.adasInspection
      }
      return _data
    },
    // Issue 556: only surface the Invoice button for "real" reports — an inspection tied to a
    // proper repair. A non-empty estimate source ('M' Mitchell / 'C' CCC) is the signal that a
    // repair/estimate is attached; identified-only inspections (no repair, no source) have no
    // ADAS MAP transaction charge to invoice, so the button is hidden for them.
    hasEstimateSource() {
      let _has = false
      if (this.inspection && this.inspection.estimateSource) {
        _has = String(this.inspection.estimateSource).trim() !== ''
      }
      return _has
    },
    vehicle() {
      let _data = null
      if (this.inspection) {
        _data = this.inspection.vehicle
      }
      return _data
    },
    vin() {
      let _data = null
      if (this.inspection) {
        _data = this.inspection.vehicle ? this.inspection.vehicle.vin : null
      }
      return _data
    },
    isResponseThere() {
      let _is = false
      if (this.aiResponse && this.aiResponse.results) {
        if (this.aiResponse.results.length > 0) {
          _is = true
        }
      }
      return _is
    },
    isExecutingPrompt() {
      let _is = false
      if (this.loading) {
        _is = this.loading.aiResponse
      }
      return _is
    },
    oemLink() {
      const foundLink = this.oemLinks.find(link => link.make.toLowerCase() === this.make.toLowerCase())
      if (foundLink) {
        if (foundLink.href.indexOf('http') === -1 && foundLink.href) {
          return this.oem1StopLink + foundLink.href
        } else if (foundLink.href.indexOf('http') !== -1) {
          return foundLink.href
        }
      }
      return this.oem1StopLink
    }
  },
  methods: {
    ...mapActions(inspectionStore, ['setInspection', 'getInspection']),
    ...mapActions(aiStore, ['resetPrompt', 'getAi', 'saveAiPrompt', 'deleteAiPrompt']),
    ...mapActions(lookupStore, ['getRepairPlanItems', 'getVehicleScans', 'getOptInInsurers']),
    init() {
      this.resetPrompt()
      window.addEventListener('message', this.handleIframeMessage)
      if (this.$refs.refAdasInspection) {
        this.isThere = true
        let config = this.$refs.refAdasInspection.getConfig()
        this.isBMS = config.isBMS
        this.isCCC = config.isCCC
      }
    },
    handleIframeMessage(event) {
      const { type, data } = event.data
      console.log('Received message from iFrame:', type, data)
      if (type === 'isLoaded') {
        this.isLoading = false
        this.setResultSaving(false)
        if (this.isGoingToProviders && this.isProvider) {
          this.$refs.refAdasInspection.gotoProviders()
        }
        this.isGoingToProviders = false
      } else if (type === 'inspectionTab') {
        this.inspectionTab = data
      } else if (type === 'isBMS') {
        this.isBMS = data
      } else if (type === 'isCCC') {
        this.isCCC = data
      } else if (type === 'isComplete') {
        this.isComplete = data
      } else if (type === 'dontShow') {
        this.dontShow = data
      } else if (type === 'status') {
        this.inspectionTab = data.inspectionTab
        this.isBMS = data.isBMS
        this.isCCC = data.isCCC
        this.isComplete = data.isComplete
        this.dontShow = data.dontShow
        this.isSave = data.isSave
      } else if (type === 'showReport') {
        this.$emit('report', data)
      } else if (type === 'isSave') {
        this.isSave = data
      } else if (type === 'isResultSaving') {
        this.setResultSaving(data)
      } else if (type === 'isLoadedMCP') {
        this.isLoading = false
        if (data.status === 'notfound') {
          this.mcpLoaded = false
        }
      }
    },
    // Issue 655: the ADAS Map iframe is v-if'd, so leaving the tab mid-save would destroy it and
    // could abort the save. Lock tabs/close while a results save is in flight; the timer is a
    // safety net so a lost 'false' message can't leave the dialog locked.
    setResultSaving(isSaving) {
      clearTimeout(this.resultSavingTimer)
      this.resultSavingTimer = null
      this.isResultSaving = !!isSaving
      if (this.isResultSaving) {
        this.resultSavingTimer = setTimeout(() => this.setResultSaving(false), 30000)
      }
    },
    close() {
      if (this.isResultSaving) return
      this.isSave = false
      this.isLinesStale = false
      this.currentTab = 'Line Items'
      this.$emit('closing')
    },
    async setTab(value) {
      this.isGoingToProviders = false
      // Issue 655: anything changed in ADAS Map (OR level, Not Equipped, add-to-build, scrub)
      // alters the line items, so reload them on the way back instead of showing the cached copy
      if (this.currentTab === 'ADAS Map' && value !== 'ADAS Map') {
        this.isLinesStale = true
      }
      this.currentTab = value
      if (this.currentTab === 'Line Items' && this.isLinesStale && this.inspection) {
        this.isLinesStale = false
        await this.refreshInspection()
      }
      if (this.currentTab === 'Mobile Copilot') {
        this.mcpLoaded = true
      }
      if (this.currentTab === 'Assistants') {
        this.resetPrompt()
        await this.getAi({
          ai: null,
          firm: 1,
          name: null
        })
      } else if (this.currentTab === 'Repair Plan Info') {
        console.log('Repair Plan Info:', this.inspection)
        let data = null
        if (this.inspection) {
          data = {
            firm: this.inspection.firm,
            vehicleMake: this.inspection.vehicle ? this.inspection.vehicle.makeId : null,
            year: this.inspection.vehicle ? this.inspection.vehicle.year : null
          }
          await this.getRepairPlanItems(data)
        }
      } else if (this.currentTab === 'Scans') {
        if (this.inspection) {
          if (this.inspection.vehicle) {
            await this.getVehicleScans(this.inspection.vehicle.vin)
          }
        }
      }
    },
    changed() {
      this.isSave = true
    },
    showRepairLines() {
      this.$refs.refAdasInspection.showRepairLines()
    },
    scrubRepairData() {
      this.$refs.refAdasInspection.scrubRepairData()
    },
    emailReport() {
      this.$refs.refAdasInspection.emailReport()
    },
    showReport() {
      this.$refs.refAdasInspection.showReport()
    },
    // Issue 556: open the ADAS MAP PRO transaction-charge invoice in the report preview dialog.
    showInvoice() {
      this.$emit('report', { reportName: 'Invoice', adasInspection: this.adasInspection })
    },
    pushReportToCCC() {
      this.$refs.refAdasInspection.pushReportToCCC()
    },
    sendToCalCopilot() {
      this.$refs.refAdasInspection.sendToCalCopilot()
    },
    completeInspection() {
      this.$refs.refAdasInspection.completeInspection()
    },
    async refreshInspection() {
      await this.getInspection(this.inspection.adasInspection)
      this.$emit('refresh')
    },
    closeModal() {
      this.actionConfirm = null
      this.actionAIPrompt = null
    },
    selectAiPrompt(ai, isRefresh = false) {
      this.selectedPrompt = null
      this.actionAIPrompt = null
      this.selectedPrompt = this.aiListItems.find(item => item.ai === ai)
      console.log('Selecting AI Prompt:', {
        ai: this.selectedAi,
        selected: this.selectedPrompt
      })
      if (ai === -1 || ai === -2) {
        this.selectedPrompt = null
      }
      if (this.selectedPrompt.action === 'select' && !this.isSuperAdmin) {
        setTimeout(() => {
          this.$refs.aiPrompt.fetchAiResponse(isRefresh)
        }, 200)
      }
    },
    runAiPrompt() {
      this.$refs.aiPrompt.fetchAiResponse(true)
    },
    addPrompt() {
      this.selectedAi = -2
      this.selectedPrompt = null
      this.actionAIPrompt = {
        ai: null,
        firm: 1,
        aiName: null,
        action: 'new'
      }
    },
    async editPrompt() {
      await this.getAi({
        ai: this.selectedPrompt.ai,
        firm: null,
        name: null
      })
      if (this.aiPrompt) {
        this.actionAIPrompt = {
          ai: this.selectedPrompt.ai,
          firm: this.selectedPrompt.firm,
          aiName: this.selectedPrompt.aiName,
          aiRole: this.aiPrompt.aiRole,
          aiModel: this.aiPrompt.aiModel,
          prompt: this.aiPrompt.prompt,
          action: 'edit'
        }
      }
    },
    deletePrompt() {
      this.actionConfirm = true
    },
    printResponse() {
      if (this.aiResponse && this.aiResponse.results) {
        this.printToPdf(this.aiResponse.results)
      }
    },
    printToPdf(htmlString) {
      // 1. Open a new window
      const printWindow = window.open('', '_blank')
      // 2. Write a full HTML document with your styles in the <head>
      printWindow.document.open();
      printWindow.document.write(htmlString)
      printWindow.document.close()
      // 3. Wait for content to load, then trigger print
      printWindow.onload = () => {
        printWindow.focus()
        printWindow.print()
        // Optionally close window after printing
        printWindow.onafterprint = () => printWindow.close();
      }
    },
    async performConfirmation() {
      if (this.selectedAi) {
        this.actionAIPrompt = null
        await this.deleteAiPrompt(this.selectedAi)
        this.selectedAi = -2
        await this.getAi({
          ai: null,
          firm: 1,
          name: null
        })
      }
      this.actionConfirm = null
    },
    async savePrompt(ai) {
      this.actionAIPrompt = null
      await this.saveAiPrompt(ai)
      await this.getAi({
        ai: null,
        firm: 1,
        name: null
      })
    },
    saveInspection(closeIt) {
      this.isSaving = false
      this.isSave = false
      this.$refs.refAdasInspection.saveInspection(closeIt)
      if (closeIt) {
        this.currentTab = 'Line Items'
        this.$emit('closing')
      }
    },
    gotoProviders() {
      this.currentTab = 'ADAS Map'
      this.isGoingToProviders = true
    },
    gotoAllData() {
      window.open(this.alldataLink, '_blank')
    },
    gotoICarRTS() {
      const link = this.rtsICarLink
      if (link) {
        window.open(link, '_blank')
      } else {
        console.error('No valid I-Car RTS link found for make:', this.make)
      }
    },
    // gotoFITREV() {
    //   const link = this.fitRevLink
    //   if (link) {
    //     window.open(link, '_blank')
    //   } else {
    //     console.error('No valid FIT REV link found')
    //   }
    // },
    gotoOEM1Stop() {
      const link = this.oemLink
      if (link) {
        window.open(link, '_blank')
      } else {
        console.error('No valid OEM link found for make:', this.make)
      }
    },
    insuranceNameFor(insurance) {
      let found = this.insuranceCompanies.find((option) => parseInt(option.value) === parseInt(insurance))
      return found ? found.name : '(unknown)'
    },
    pricingSourceLabel(source, detail) {
      if (!source) return 'None'
      let label = source === 'insurer' ? 'Insurance' : source.charAt(0).toUpperCase() + source.slice(1)
      return detail ? `${label} (${detail})` : label
    },
    pricingSnapshot() {
      let total = 0
      if (this.inspection && this.inspection.results) {
        for (const result of this.inspection.results) {
          total += (result.price ?? 0) - (result.discount ?? 0)
        }
      }
      return {
        insuranceName: this.inspection && this.inspection.insuranceName ? this.inspection.insuranceName : '(none)',
        source: this.pricingSourceLabel(this.inspection?.pricingSource, this.inspection?.pricingDetail),
        total
      }
    },
    cancelInsuranceChange() {
      this.pendingInsurance = null
      this.actionInsuranceConfirm = false
    },
    async confirmInsuranceChange() {
      this.actionInsuranceConfirm = false
      let value = this.pendingInsurance
      let before = this.pricingSnapshot()
      // await the save before re-fetching, or DiagnosticLines_Get re-runs
      // against the old insurance
      await this.setInspection({
        name: 'insurance',
        value: value
      })
      await this.refreshInspection()
      this.pendingInsurance = null
      let after = this.pricingSnapshot()
      const money = (n) => `$${n.toFixed(2)}`
      this.insuranceSummaryHtml =
        `Insurance: <b>${before.insuranceName}</b> &rarr; <b>${after.insuranceName}</b><br/>` +
        `Pricing source: <b>${before.source}</b> &rarr; <b>${after.source}</b><br/>` +
        `Line items total: <b>${money(before.total)}</b> &rarr; <b>${money(after.total)}</b>`
      this.actionInsuranceSummary = true
    }
  },
  beforeUnmount() {
    clearTimeout(this.resultSavingTimer)
    this.currentTab = 'Line Items'
    this.emitter.off('process-consumables')
    window.removeEventListener('message', this.handleIframeMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleIframeMessage)
  }
}
</script>
<style lang="scss" scoped>
.custom-header-wrapper {
  width: 100%;
}

.custom-header {
  display: grid;
}

.custom-header-title {
  font-size: 1.3rem;
  font-weight: bold;
}

.custom-textarea {
  height: 200px;
}

.custom-close {
  float: right;
  margin-right: 10px;
  color: #000;
  cursor: pointer;
}

.custom-footer {
  position: relative;
  width: 100%;
  display: inline-flex;
}

.custom-right-align {
  text-align: right;
  float: right;
}

.hostWrapper {
  max-height: 750px;
  overflow-x: hidden;
  overflow-y: hidden;
  height: 680px;
}

// ADAS IQ tab (710): the tabs row, then the chat filling the rest of the body. On a short
// window the body shrinks so the whole chat (header to input) stays inside the dialog: the
// dialog's header and footer take up to ~305px (a wrapped title, wrapped footer buttons)
// and the dialog sits 29px from each edge. Every other tab keeps the fixed 680px body.
.hostWrapper.custom-host-adasiq {
  display: flex;
  flex-direction: column;
  height: min(680px, calc(100vh - 315px));
  min-height: 280px;
}

.custom-adasiq-tab {
  flex: 1 1 auto;
  min-height: 0;

  > .col {
    height: 100%;
  }

  // The embed's own 320px floor would push its input under the dialog footer on a short window.
  :deep(.adasiq-embed) {
    min-height: 0;
  }
}

.custom-ai-wrapper {
  border: 1px solid #dadada;
  padding: 5px;
  margin: 5px;
  height: 91%;
}

.custom-prompt-wrapper {
  border: 2px solid #ff0000;
  padding: 5px;
}

.custom-spacer {
  margin-left: 2px !important;
}

.custom-actions {
  display: flex;
  justify-content: center;
}

.custom-actions-button {
  border-left: 2px solid #ffffff;
}
</style>
